import { Link, useRouteError } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

export default function NotFoundPage() {
  const error = useRouteError() as { statusText?: string; message?: string } | undefined

  return (
    <>
      <Helmet>
        <title>404 - Page Not Found</title>
      </Helmet>
      <section className="section min-h-screen flex items-center justify-center">
        <div className="text-center max-w-md">
          <p className="text-8xl font-bold text-gray-200 select-none">404</p>
          <h1 className="text-2xl font-semibold mt-4 text-gray-900">Page not found</h1>
          <p className="text-gray-500 mt-2">
            {error?.statusText ?? error?.message ?? "The page you're looking for doesn't exist."}
          </p>
          <Link to="/" className="btn-primary mt-8 inline-block">
            Go home
          </Link>
        </div>
      </section>
    </>
  )
}
